import { useGenericMutation } from '@hooks/use-generic-mutation';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { AuthTokenResponse } from './type';

const signin = async (email: string, password: string) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/signin`;

  return request({ url, method: RequestMethod.POST, body: { email, password } });
};

export const useSignin = ({ hideError }: { hideError?: boolean } = {}) => {
  return useGenericMutation<AuthTokenResponse, RequestError, { email: string; password: string }>(
    [QUERY_KEYS.signin],
    async ({ email, password }: { email: string; password: string }) => signin(email, password),
    undefined,
    hideError
  );
};
